import {
  Box,
  styled,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  TextField,
  Button,
  TableCell,
  Table,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  TableBody,
} from '@mui/material';
import { toast } from 'react-toastify';
import useLoadDataList from 'src/hook/useLoadDataList';
import { deleteStock, getStocks } from 'src/services/stock';
import { handleMutation } from 'src/utils/api.utils';

export const ListAssemblyStock = () => {
  const { data: stocks, onRefresh } = useLoadDataList(getStocks);

  const handleDelete = (id: string) => {
    handleMutation(
      (data) => deleteStock(data),
      id,
      () => {
        toast.success('Stock supprimé avec succès');
        onRefresh();
      },
    );
  };

  return (
    <Container>
      <Typography variant="h6" gutterBottom>
        Liste des stocks
      </Typography>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: '30%' }}>Nom</TableCell>
              <TableCell sx={{ width: '20%' }}>Granits</TableCell>
              <TableCell sx={{ width: '20%' }}>Quantité</TableCell>
              <TableCell sx={{ width: '20%' }}>Prix</TableCell>
              <TableCell sx={{ width: '10%' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {stocks?.map((stock) => {
              const piecesGranits = stock.stockPieces?.map((piece) => piece.granit?.name);
              const stelesGranits = stock.stockSteles?.map((stele) => stele.granit?.name);
              const platingsGranits = stock.stockPlatings?.map((plating) => plating.granit?.name);
              const solesGranits = stock.stockSoles?.map((sole) => sole.granit?.name);

              const granits = [
                ...new Set([
                  ...(piecesGranits || []),
                  ...(stelesGranits || []),
                  ...(platingsGranits || []),
                  ...(solesGranits || []),
                ]),
              ];

              return (
                <TableRow key={stock.id}>
                  <TableCell>{stock.name}</TableCell>
                  <TableCell>{granits.join(', ')}</TableCell>
                  <TableCell>{stock.quantity}</TableCell>
                  <TableCell>{stock.price}</TableCell>
                  <TableCell sx={{ display: 'flex', gap: 1 }}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleDelete(stock.id!)}
                    >
                      Supprimer
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  );
};

const Container = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  padding: '20px',
});

const Form = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
});

const Row = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
});
